import 'tslib';
import 'long';
import '../../proto/index.js';
import { ErrorType } from '../../core/consts.js';
import { LoggerLevel } from '../../core/metrics/logger.js';
import '../../core/metrics/monitor.js';
import '../../core/service/RuntimeContext.js';
import '../../core/network/NetworkItem.js';
import 'json-long';
import 'moize';
import '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../../adapter/manager/AdapterManager.js';
import '../../adapter/manager/types.js';
import '../../core/utils/ticker.js';
import '../../adapter/abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';

class SlardarWebMonitor {
    constructor(inst) {
        this.slardar = inst;
    }
    emitError(error, tagKv) {
        if (typeof this.slardar.captureException !== 'function') {
            return;
        }
        if (error.type !== ErrorType.NetworkError) {
            this.slardar.captureException(error, Object.assign(Object.assign({}, tagKv), { type: `${error.type}:${ErrorType[error.type]}`, msg: error.msg, logid: error.logid, args: error.args }));
        }
    }
    emitNetwork(req, resp, tagKv) {
        if (resp !== undefined) {
            if (resp.status_code !== 0) {
                this.slardar.sendLog({
                    level: 'error',
                    content: `Response Error:${resp.status_code}, cmd: ${resp.cmd} msg: ${resp.error_desc}, logid: ${resp.log_id}`,
                    extra: Object.assign({ cmd: `${resp.cmd}` }, tagKv)
                });
            }
        }
    }
    emitEvent(event, sender, args) {
        return;
    }
    emitLog(level, args) {
        if (level === LoggerLevel.debug) {
            // 不上报 debug 日志
            return;
        }
        const tags = {};
        args.forEach((val, idx) => {
            tags[idx] = val;
        });
        this.slardar.sendLog({
            level: LoggerLevel[level],
            content: args.join(','),
            extra: Object.assign({}, tags)
        });
    }
    emitTracker(name, tagKv) {
        this.slardar.sendLog({
            level: 'debug',
            content: name,
            extra: tagKv
        });
    }
    emitMetrics(name, metrics = {}, tagKv = {}) {
        // TODO: 迁移到 TEA
        // this.slardar.sendEvent({
        //     name,
        //     metrics,
        //     categories: tagKv
        // });
    }
}

export { SlardarWebMonitor };
//# sourceMappingURL=SlardarWebMonitor.js.map
